import React, { useState, useEffect, useRef } from "react";

import allumerLaVoitureFrame1 from "assets/puzzles/iserba/roadSafety/allumer-la-voiture-frame-1.svg";
import allumerLaVoitureFrame2 from "assets/puzzles/iserba/roadSafety/allumer-la-voiture-frame-2.svg";
import interieurVoiture from "assets/puzzles/iserba/roadSafety/interieur_voiture.svg";

const IserbaGame1Transition = ({ handleTransitionEnd }) => {
	const gridRef = useRef(null);
	const imageRef = useRef(null);
	const [gridSize, setGridSize] = useState(0);
	const [image, setImage] = useState(allumerLaVoitureFrame1);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	const handleImageClick = () => {
		if (image === allumerLaVoitureFrame1) {
			setImage(allumerLaVoitureFrame2);
			// Shake the image for three seconds and then invoke next
			if (imageRef.current) {
				const shakeAnimation = imageRef.current.animate(
					[
						{ transform: "translate(0, 0)" },
						{ transform: "translate(-5px, 0)" },
						{ transform: "translate(5px, 0)" },
						{ transform: "translate(0, 0)" },
					],
					{
						duration: 300,
						iterations: 3,
					}
				);
				shakeAnimation.finished.then(() => {
					setTimeout(() => {
						setImage(interieurVoiture);
						setTimeout(() => {
							handleTransitionEnd();
						}, 2000);
					}, 1000);
				});
			}
		}
	};

	return (
		<div className="relative flex flex-col items-start non-selectable">
			<div
				ref={gridRef}
				className="relative m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)] bg-black"
				style={{
					width: gridSize,
					height: gridSize,
				}}
			>
				<img
					ref={imageRef}
					src={image}
					alt="Transition"
					className="absolute top-0 left-0 w-full h-full object-cover"
					onClick={handleImageClick}
				/>
			</div>

			<div className="mt-4 h-24 px-4 mb-8"></div>
		</div>
	);
};

export default IserbaGame1Transition;
